import React, { useState, useEffect, useRef } from "react";
import "./ForgotPassword.css";
import { Spinner } from "@chakra-ui/react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { useDispatch } from "react-redux";
import {
  forgotPassWordUser,
  changeUserPassword,
  verifyForgotPassword,
} from "../../../../redux/reduxApi/SingIn&SingUp/ForgotpasswordAPI";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [timer, setTimer] = useState(0);
  const [timerActive, setTimerActive] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]); // Changed to 6 digits
  const combinedOtp = otp.join("");
  const inputRefs = useRef([]);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const dispatch = useDispatch();

  const sendEmail = async (e) => {
    e.preventDefault();

    const data = {
      email,
      otp: combinedOtp,
    };
    console.log("Data:", data);
    setIsLoading(true);

    try {
      const otpResp = await dispatch(forgotPassWordUser(data));
      console.log("Forgot password otp send  API Response:", otpResp);
      if (otpResp.payload.data.success) {
        setIsLoading(false);

        toast.success("OTP sent successfully!");
        setTimer(60);
        setTimerActive(true);
        setOtpSent(true);
      }
    } catch (e) {
      setIsLoading(false);
      toast.error("An error occurred. Please try again.");
      console.log(e);
    }
  };

  useEffect(() => {
    let interval;
    if (timerActive && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setTimerActive(false);
      setOtpSent(false); // Allow resending OTP after timer ends
    }
    return () => clearInterval(interval);
  }, [timerActive, timer]);

  const verifyOTP = async (e) => {
    e.preventDefault();

    const data = {
      email,
      otp: combinedOtp,
    };

    // Check if OTP is complete (all 6 digits)
    if (combinedOtp.length !== 6) {
      toast.error("Please enter the complete 6-digit OTP");
      return;
    }

    setIsLoading(true);

    try {
      const otpResp = await dispatch(verifyForgotPassword(data));
      console.log("Forgot password otp verify API Response:", otpResp);
      const resetToken = otpResp.payload.resetToken;
      localStorage.setItem("resetToken", resetToken);
      if (otpResp.payload.success) {
        setIsLoading(false);
        toast.success("OTP verified successfully!");
        setIsOtpVerified(true);
      } else {
        toast.error("Invalid OTP Verification");
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
      toast.error("An error occurred. Please try again.");
      console.log(e);
    }
  };

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (e.key === "ArrowRight" && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    } else if (e.key === "Enter" && combinedOtp.length === 6) {
      verifyOTP(e);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text");
    const otpDigits = pastedData.replace(/\D/g, "").slice(0, 6).split("");

    if (otpDigits.length === 6) {
      const newOtp = [...otp];
      otpDigits.forEach((digit, index) => {
        newOtp[index] = digit;
      });
      setOtp(newOtp);

      // Focus on the last input
      if (inputRefs.current[5]) {
        inputRefs.current[5].focus();
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (password.length < 8) {
      setPasswordError("Password must be at least 8 characters long.");
      return;
    } else if (password !== confirmPassword) {
      setPasswordError("Passwords do not match!");
      return;
    }

    setPasswordError(""); // Clear error if all conditions are met
    setIsLoading(true);
    try {
      const data = {
        newPassword: password,
        // confPassword: confirmPassword,
        email: email,
        resetToken: localStorage.getItem("resetToken"),
      };
      const response = await dispatch(changeUserPassword(data));
      console.log(
        "Forgot password submit new password API Response:",
        response
      );
      if (response.payload.success) {
        setIsLoading(false);
        toast.success("Password changed successfully!");
        navigate("/login");
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error changing password:", error);
      toast.error("Error changing password: Please try again.");
    }
  };

  return (
    <>
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="green.500" />
        </div>
      )}
      <div className="flex items-center justify-center w-full h-full signin-main-div mt-2">
        <div className="form_container mt-2">
          <form>
            <div className="title_container">
              <p className="title text-[#661E33]">Forgot Password</p>
              <span className="subtitle  " style={{ color: '#661E33' }}
              >
                Enter your Email to receive a password reset  link.
              </span>
            </div>

            <div className="input_container">
              <label className="input_label  " htmlFor="email_field"
                style={{ color: '#661E33' }}
              >
                Email
              </label>
              <div className="d-flex">
                <input
                  placeholder="name@mail.com"
                  name="email"
                  type="email"
                  value={email}
                  className="input_field"
                  id="email_field"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="mx-2  send-otp-btn "
                  style={{ backgroundColor: '#66944B' }} // Green color
                  onClick={sendEmail}
                  disabled={timerActive}
                >
                  {timerActive ? `Send OTP (${timer})` : "Send OTP"}
                </button>
              </div>
            </div>

            <div className="input_container">
              <label className="input_label" htmlFor="otp"
                style={{ color: '#661E33' }}
              >
                Enter 6-digit OTP
              </label>
              <div className="d-flex flex-column">
                <div
                  className="d-flex justify-content-center items-center mb-3"
                  onPaste={handlePaste}
                >
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      ref={(el) => (inputRefs.current[index] = el)}
                      className="w-12 h-12 m-1 text-center font-bold"
                      style={{
                        border: "1px solid #d7d2d2",
                        color: "#661e33",
                        fontSize: "1.2rem",
                        borderRadius: "8px"
                      }}
                      type="text"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleChange(index, e)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      onFocus={(e) => e.target.select()}
                    />
                  ))}
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <button
                    type="button"
                    className="verify-otp-btn h-10 px-4"
                    onClick={verifyOTP}
                    disabled={combinedOtp.length !== 6}
                    style={{
                      backgroundColor: '#66944B',
                      opacity: combinedOtp.length === 6 ? 1 : 0.5,
                      cursor: combinedOtp.length === 6 ? 'pointer' : 'not-allowed'
                    }}

                  >
                    Verify OTP
                  </button>
                  {otpSent && timer === 0 && (
                    <button
                      type="button"
                      className="resend-otp-btn text-sm text-blue-600 hover:text-blue-800"
                      onClick={sendEmail}
                    >
                      Resend OTP
                    </button>
                  )}
                </div>
              </div>
            </div>

            {isOtpVerified && (
              <>
                <div className="input_container">
                  <label className="input_label" htmlFor="password_field">
                    Create New Password
                  </label>
                  <div
                    className="d-flex rounded-3 text-center"
                    style={{ border: "1px solid #EEEEEE", height: "50px" }}
                  >
                    <input
                      placeholder="Password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      id="password_field"
                      required
                      onChange={(e) => setPassword(e.target.value)}
                      style={{ border: "none" }}
                      className="form-control border-0 shadow-none px-3 py-2 text-gray-600"
                    />

                    <span
                      onClick={togglePasswordVisibility}
                      className="d-flex mx-2 "
                      style={{ alignItems: "center", cursor: "pointer" }}
                    >
                      {showPassword ? (
                        <Eye className="cursor-pointer" />
                      ) : (
                        <EyeOff className="cursor-pointer" />
                      )}
                    </span>
                  </div>
                </div>

                {passwordError && (
                  <p className="error_message">{passwordError}</p>
                )}

                <div className="input_container">
                  <label
                    className="input_label"
                    htmlFor="confirm_password_field"
                  >
                    Confirm Password
                  </label>
                  <div
                    className="d-flex rounded-3 text-center"
                    style={{ border: "1px solid #EEEEEE", height: "50px" }}
                  >
                    <input
                      placeholder="Confirm Password"
                      name="confirmPassword"
                      type={showConfirmPassword ? "text" : "password"}
                      id="confirm_password_field"
                      required
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      style={{ border: "none" }}
                      className="form-control border-0 shadow-none px-3 py-2 text-gray-600"
                    />
                    <span
                      onClick={toggleConfirmPasswordVisibility}
                      className="d-flex mx-2 "
                      style={{ alignItems: "center", cursor: "pointer" }}
                    >
                      {showConfirmPassword ? (
                        <Eye className="cursor-pointer" />
                      ) : (
                        <EyeOff className="cursor-pointer" />
                      )}
                    </span>
                  </div>
                </div>

                <button
                  title="Submit"
                  type="submit"
                  className="sign-in_btn my-4"
                  style={{backgroundColor: '#66944B',}}
                  onClick={handleSubmit}
                >
                  <span>Submit</span>
                </button>
              </>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;